// 设备检测工具

/**
 * 检测是否为移动设备
 * @returns {boolean} 是否为移动设备
 */
export function isMobile() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
}

/**
 * 检测是否为桌面设备
 * @returns {boolean} 是否为桌面设备
 */
export function isDesktop() {
  return !isMobile();
}

/**
 * 获取设备类型
 * @returns {string} 设备类型：'mobile' 或 'desktop'
 */
export function getDeviceType() {
  return isMobile() ? 'mobile' : 'desktop';
}